import { BusinessInfoLine } from '../../../MobileInvoiceView/InvoicesBusinessInfo/BusinessInfoLine';
import * as React from 'react';
import { translate } from 'react-i18next';
export var BusinessPhone = translate()(function (_a) {
    var phone = _a.phone, t = _a.t;
    return phone ? (React.createElement(BusinessInfoLine, { dataHook: "business-phone", verticalLayout: true, value: t('invoice-view:price-quote.view.business.phone', { phone: phone }) })) : null;
});
//# sourceMappingURL=BusinessPhone.js.map